export default "__VITE_ASSET__BW0AIiQ6__"